import PrivateRoute from 'components/routes/PrivateRoute';
import AccountDashboard from 'pages/AccountDashboard';
import AdminDashboard from 'pages/AdminDashboard';
import BookingDashboard from 'pages/BookingDashboard';
import BookingReporting from 'pages/BookingReporting';
import BookingsLive from 'pages/BookingsLive';
import BuildingDashboard from 'pages/BuildingDashboard';
import CardDashboard from 'pages/CardDashboard';
import ForgotPassword from 'pages/ForgotPassword';
import FunctionDashboard from 'pages/FunctionDashboard';
import IntegrationDashboard from 'pages/IntegrationDashboard';
import IntegrationKeysDashboard from 'pages/IntegrationKeysDashboard';
import IntegrationPreferencesDashboard from 'pages/IntegrationPreferencesDashboard';
import Login from 'pages/Login';
import ManageResourcesDashboard from 'pages/ManageResourcesDashboard';
import NotFound from 'pages/NotFound';
import OccupantsDashboard from 'pages/OccupantsDashboard';
import OrgDashboard from 'pages/OrgDashboard';
import PasswordReset from 'pages/PasswordReset';
import CreatePassword from 'pages/CreatePassword';
import ResourceDashboard from 'pages/ResourcesDashboard';
import SensorsDashboard from 'pages/SensorsDashboard';
import SpaceDashboard from 'pages/SpaceDashboard';
import SpaceLive from 'pages/SpaceLive';
import SpaceReporting from 'pages/SpaceReporting';
import SurveyDashboard from 'pages/SurveyDashboard';
import TrainerDashboard from 'pages/TrainerDashboard';
import TypeDashboard from 'pages/TypeDashboard';
import UnitDashboard from 'pages/UnitDashboard';
import VisitorsDashboard from 'pages/VisitorsDashboard';
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { ROLE } from 'utils/roles';
import MyProfileDashboard from 'pages/MyProfileDashboard';
import AIAssistantDashboard from 'pages/AIAssistantDashboard';

const RoutesInfo = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<Login />} />
      <Route path="password-reset/:token" element={<PasswordReset />} />
      <Route path="create-password/:token" element={<CreatePassword />} />
      <Route path="forgot-password" element={<ForgotPassword />} />

      {/* Private Route */}
      {/* Routes for Super user */}
      <Route
        path="/admins"
        element={
          <PrivateRoute roles={[ROLE.Super, ROLE.Account]}>
            <AdminDashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/trainer"
        element={
          <PrivateRoute roles={[ROLE.Super]}>
            <TrainerDashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/surveys"
        element={
          <PrivateRoute roles={[ROLE.Super]}>
            <SurveyDashboard />
          </PrivateRoute>
        }
      />

      {/* Routes for Super user and Account user */}
      <Route
        path="/accounts"
        element={
          <PrivateRoute roles={[ROLE.Super, ROLE.Account]}>
            <AccountDashboard />
          </PrivateRoute>
        }
      />

      {/* Routes for Super user, Account user and Building user */}
      <Route
        path="/buildings"
        element={
          <PrivateRoute roles={[ROLE.Super, ROLE.Account, ROLE.Building]}>
            <BuildingDashboard />
          </PrivateRoute>
        }
      />

      {/* Routes for Super user, Account user, Building user and Organization user */}
      <Route
        path="/organizations"
        element={
          <PrivateRoute roles={[ROLE.Super, ROLE.Account, ROLE.Building, ROLE.Org]}>
            <OrgDashboard />
          </PrivateRoute>
        }
      />

      {/* Routes for Super user, Account user, Building user and Organization user */}
      <Route
        path="/occupants"
        element={
          <PrivateRoute roles={[ROLE.Super, ROLE.Account, ROLE.Building, ROLE.Org]}>
            <OccupantsDashboard />
          </PrivateRoute>
        }
      />

      {/* Routes for Super user, Account user, Building user and Organization user */}
      <Route
        path="/cards"
        element={
          <PrivateRoute roles={[ROLE.Super, ROLE.Account, ROLE.Building]}>
            <CardDashboard />
          </PrivateRoute>
        }
      />

      {/* Routes for Super user, Account user and Building user */}
      <Route
        path="/visitors"
        element={
          <PrivateRoute roles={[ROLE.Super, ROLE.Account, ROLE.Building]}>
            <VisitorsDashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/spaces"
        element={
          <PrivateRoute roles={[ROLE.Super, ROLE.Account, ROLE.Building]}>
            <SpaceDashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/spaces/live"
        element={
          <PrivateRoute roles={[ROLE.Super, ROLE.Account, ROLE.Building]}>
            <SpaceLive />
          </PrivateRoute>
        }
      />
      <Route
        path="/spaces/reporting"
        element={
          <PrivateRoute roles={[ROLE.Super, ROLE.Account, ROLE.Building]}>
            <SpaceReporting />
          </PrivateRoute>
        }
      />
      <Route
        path="/spaces/manage"
        element={
          <PrivateRoute roles={[ROLE.Super, ROLE.Account, ROLE.Building]}>
            <SpaceDashboard />
          </PrivateRoute>
        }
      />

      {/* Routes for Super, Account and Building users */}
      <Route
        path="/ai-assistant"
        element={
          <PrivateRoute roles={[ROLE.Super, ROLE.Account, ROLE.Building]}>
            <AIAssistantDashboard />
          </PrivateRoute>
        }
      />

      {/* Routes for Super user only */}
      <Route
        path="/integrations"
        element={
          <PrivateRoute roles={[ROLE.Super]}>
            <IntegrationDashboard />
          </PrivateRoute>
        }
      />

      {/* Routes for Super user only */}
      <Route
        path="/integration-preferences"
        element={
          <PrivateRoute roles={[ROLE.Super]}>
            <IntegrationPreferencesDashboard />
          </PrivateRoute>
        }
      />

      {/* Routes for Super user only */}
      <Route
        path="/integration-keys"
        element={
          <PrivateRoute roles={[ROLE.Super]}>
            <IntegrationKeysDashboard />
          </PrivateRoute>
        }
      />

      {/* Routes for Super user only */}
      <Route
        path="/sensors"
        element={
          <PrivateRoute roles={[ROLE.Super]}>
            <SensorsDashboard />
          </PrivateRoute>
        }
      />

      {/* Routes for Super user, Account user, Building user, Organization user and Mobile user */}
      <Route
        path="/bookings"
        element={
          <PrivateRoute roles={[ROLE.Super, ROLE.Account, ROLE.Building, ROLE.Org]}>
            <BookingDashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/bookings/live"
        element={
          <PrivateRoute roles={[ROLE.Super, ROLE.Account, ROLE.Building, ROLE.Org]}>
            <BookingsLive />
          </PrivateRoute>
        }
      />
      <Route
        path="/bookings/reporting"
        element={
          <PrivateRoute roles={[ROLE.Super, ROLE.Account, ROLE.Building, ROLE.Org]}>
            <BookingReporting />
          </PrivateRoute>
        }
      />
      <Route
        path="/bookings/manage"
        element={
          <PrivateRoute roles={[ROLE.Super, ROLE.Account, ROLE.Building, ROLE.Org]}>
            <BookingDashboard />
          </PrivateRoute>
        }
      />

      {/* Routes for Super user, Account user and Building user for Resources */}
      <Route
        path="/resources"
        element={
          <PrivateRoute roles={[ROLE.Super, ROLE.Account, ROLE.Building]}>
            <ResourceDashboard />
          </PrivateRoute>
        }
      />

      {/* Routes for Super user, Account user and Building user for Resources */}
      <Route
        path="/manage-resources/:resourceUUID"
        element={
          <PrivateRoute roles={[ROLE.Super, ROLE.Account, ROLE.Building]}>
            <ManageResourcesDashboard />
          </PrivateRoute>
        }
      />

      {/* Routes for Super user only */}
      <Route
        path="/functions"
        element={
          <PrivateRoute roles={[ROLE.Super]}>
            <FunctionDashboard />
          </PrivateRoute>
        }
      />

      {/* Routes for Super user only */}
      <Route
        path="/units"
        element={
          <PrivateRoute roles={[ROLE.Super]}>
            <UnitDashboard />
          </PrivateRoute>
        }
      />

      {/* Routes for Super user only */}
      <Route
        path="/types"
        element={
          <PrivateRoute roles={[ROLE.Super]}>
            <TypeDashboard />
          </PrivateRoute>
        }
      />

      {/* Routes for Super user, Account user, Building user and Organization user */}
      <Route
        path="/profile"
        element={
          <PrivateRoute roles={[ROLE.Super, ROLE.Account, ROLE.Building, ROLE.Org]}>
            <MyProfileDashboard />
          </PrivateRoute>
        }
      />

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default RoutesInfo;
